<template>
    <div>
        <Table 
            class="margin-15"
            :columns="columns"
            :data="dataList"
            size="small">
        </Table>
        <!-- 弹框再次弹出历史版本的详情 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" @on-close="closemodalprops" v-on="modalProps.on"></component>
        </compModal>
    </div>
</template>

<script>
import { HttpGetHistoryList,HttpGetHistoryPriceItems } from "@/service/tasks";
import compLogIndex from './update.vue'
export default {
    props:['code'],
    components:{compLogIndex},
    data(){
        return {
            dataList:[],
            modalProps:{
                show: false,
            },
        }
    },
    created(){
        HttpGetHistoryList({
            templateCode:this.code
        }).then(res=>{
            console.log(res.data)
            this.dataList = res.data
        })
    },
    computed:{
        columns(){
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width:70,
                },
                {
                    title: "操作",
                    align: "center",
                    render: (h, { row }) => {
                        return (
                            <div>
                                <Button size="small" type="primary" onClick={this.handleQuery.bind(this, row)}>查看</Button>
                            </div>
                        );
                    },
                },
                {
                    title: "版本号",
                    key: "version",
                    align: "center",
                },
                {
                    title: "操作人",
                    key: "opUserName",
                    align: "center",
                },
                {
                    title: "操作时间",
                    key: "opAt",
                    align: "center",
                },
            ]
        }
    },
    methods:{
        handleQuery(row){
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show:true,
                width:1200,
                title:'历史版本查看',
                component:'compLogIndex',
                activeid:row.templateId,
                logcode:row.templateCode,
                logversion:row.version,
                querytype:'query',
                showFooter:false,
            }
        },
        closemodalprops(){
            this.$emit('on-openCloseable');
            this.modalProps = {};
        }
    }
}
</script>